module.exports = __webpack_public_path__ + "img/9788958074434.9142865c.jpg";